export default "__VITE_ASSET__BsxanfWd__"